import { addToCart } from '@/lib/gtmHelper'
import { cartError, cartSuccess } from '@/lib/cartResponse.js'

export function addVariant(variant, quantity, callback) {
    return fetchCart().then(({ items }) => {
        return addItemById(variant.id, quantity, function () {
            callback()
        })
    })
}

export function updateAddon(id, quantity) {
  return changeAddon(id, quantity) // shopify cart is a 1-based index
}

export function removeAddon(id) {
    return updateAddon(id, 0)
}

function changeAddon(line, quantity) {
    document.dispatchEvent(new CustomEvent('cart:updating'))

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: line, quantity }),
    })
      .then((res) => res.json())
      .then((cart) => {
        if (cart.status !== 422) {
          window.theme.cart = cart
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
        }

        if (cart.description && cart.status !== 200) {
          document.dispatchEvent(new CustomEvent('cart:error', { detail: { description: cart.description } }))
        }

        return cart
      })
}

export function addItemById(id, quantity, callback) {
    document.dispatchEvent(new CustomEvent('cart:updating'))

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id, quantity }),
    })
        .then((r) => r.json())
        .then((item) => {
            if (item.status) {
                const button = document.querySelector('.product__submit[data-product-submit]')
                if (button) {
                    button.innerHTML = item.description;
                    button.setAttribute('disabled', true)
                }
            } else {
                return fetchCart().then((cart) => {
                    window.theme.cart = cart
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item, cart } }))
                    document.dispatchEvent(new CustomEvent('updated', { detail: { item, cart } }))
                    addToCart(item)
                    if (callback) callback()
                    return { item, cart }
                })
            }
        })
}

export function fetchCart() {
    return fetch(`${Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then((res) => res.json())
}
